/* Events list: "Show all past events" and the photo reveal.
   Both are progressive: without JS, in the theme editor, or with reduced
   motion, every card shows and no photo is ever hidden. */
(function () {
	function initEventsList(root) {
		if (root.dataset.madEventsReady === 'true') return;
		root.dataset.madEventsReady = 'true';

		var designMode = window.Shopify && window.Shopify.designMode;

		/* Upcoming / Past pills swap the two panels. Liquid renders Upcoming
		   shown and Past hidden, so nothing moves on load. */
		var filters = root.querySelectorAll('[data-events-filter]');
		var panels = root.querySelectorAll('[data-events-panel]');
		root.madEventsShow = function (name) {
			panels.forEach(function (panel) {
				panel.hidden = panel.dataset.eventsPanel !== name;
			});
			filters.forEach(function (button) {
				button.setAttribute('aria-pressed', button.dataset.eventsFilter === name ? 'true' : 'false');
			});
		};
		if (filters.length) {
			filters.forEach(function (button) {
				button.addEventListener('click', function () {
					root.madEventsShow(button.dataset.eventsFilter);
				});
			});
		}

		/* Past cards beyond the section's limit wait behind one button. */
		var cards = root.querySelector('[data-past-visible]');
		var more = root.querySelector('[data-events-more]');
		if (cards && more && !designMode) {
			var limit = parseInt(cards.dataset.pastVisible, 10) || 0;
			var items = cards.children;
			if (limit && items.length > limit) {
				for (var i = limit; i < items.length; i++) items[i].hidden = true;
				more.hidden = false;
				more.querySelector('button').addEventListener('click', function () {
					var first = items[limit];
					for (var j = limit; j < items.length; j++) items[j].hidden = false;
					more.remove();
					/* Keep keyboard focus from falling back to the top of the page. */
					first.setAttribute('tabindex', '-1');
					first.focus();
				});
			}
		}

		/* Each photo fades in and settles once, the first time it scrolls into view. */
		if (
			designMode ||
			!('IntersectionObserver' in window) ||
			window.matchMedia('(prefers-reduced-motion: reduce)').matches
		) {
			return;
		}
		var photos = root.querySelectorAll('[data-reveal]');
		if (!photos.length) return;
		root.classList.add('madt-reveal-ready');
		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-inview');
					observer.unobserve(entry.target);
				});
			},
			{ threshold: 0.2 }
		);
		photos.forEach(function (photo) {
			observer.observe(photo);
		});
	}

	function initAll() {
		document.querySelectorAll('[data-events-list]').forEach(initEventsList);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	/* A section re-rendered in the theme editor arrives as new markup. */
	document.addEventListener('shopify:section:load', initAll);

	/* Selecting a past event in the theme editor opens the Past panel. */
	document.addEventListener('shopify:block:select', function (event) {
		var panel = event.target.closest && event.target.closest('[data-events-panel]');
		var root = panel && panel.closest('[data-events-list]');
		if (root && root.madEventsShow && root.querySelector('[data-events-filter]')) {
			root.madEventsShow(panel.dataset.eventsPanel);
		}
	});
})();
